'use client';

import React, { useEffect, useRef } from 'react';

import AppImage from '@/components/ui/AppImage';

const galleryImages = [
  { src: '/assets/images/Screenshot_2026-06-11_at_9.35.33_PM-1781228990382.png', alt: 'ALLYWRK candid event coverage capturing real moments' },
  { src: '/assets/images/Screenshot_2026-06-11_at_9.35.23_PM-1781228998287.png', alt: 'ALLYWRK creative direction and visual storytelling' },
  { src: '/assets/images/Screenshot_2026-06-11_at_9.32.42_PM-1781229005759.png', alt: 'ALLYWRK professional photography with cinematic color grading' },
  { src: '/assets/images/Screenshot_2026-06-11_at_9.32.29_PM-1781229013048.png', alt: 'ALLYWRK behind the scenes production work' },
  { src: '/assets/images/Screenshot_2026-06-11_at_9.32.17_PM-1781229024000.png', alt: 'ALLYWRK creative content for brand campaign' },
  { src: '/assets/images/Screenshot_2026-06-11_at_9.35.43_PM-1781228980304.png', alt: 'ALLYWRK media production showcase' },
  { src: '/assets/images/Screenshot_2026-04-25_at_8.37.55_PM-1777163944147.png', alt: 'ALLYWRK editorial portrait with dramatic lighting and bold composition' },
  { src: '/assets/images/Screenshot_2026-06-11_at_9.31.49_PM-1781229038259.png', alt: 'ALLYWRK lifestyle photography capturing authentic moments' },
  { src: '/assets/images/View_recent_photos_5-1777164663093.png', alt: 'ALLYWRK portrait session with natural light and cinematic tones' },
  { src: '/assets/images/View_recent_photos_2-1777164415151.png', alt: 'ALLYWRK brand photography for local business client' },
  { src: '/assets/images/Screenshot_2026-04-25_at_8.41.05_PM-1777164458928.png', alt: 'ALLYWRK fashion editorial with bold colors and sharp composition' },
  { src: '/assets/images/Screenshot_2026-04-25_at_8.37.22_PM-1777164937929.png', alt: 'ALLYWRK outdoor lifestyle portrait in golden hour light' },
];

export default function WorkSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.05 }
    );
    sectionRef?.current?.querySelectorAll('.reveal-on-scroll')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="work"
      style={{ background: '#0A0A0A', padding: '100px 64px' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="reveal-on-scroll mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="section-label">SELECTED WORKS</div>
            <h2
              className="text-white"
              style={{
                fontFamily: 'Bebas Neue, sans-serif',
                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                lineHeight: 0.95,
                letterSpacing: '2px',
              }}
            >
              Recent Work
            </h2>
          </div>
        </div>

        {/* Gallery grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px" style={{ border: '1px solid #1C1C1C' }}>
          {galleryImages?.map((img, i) => (
            <div
              key={i}
              className={`reveal-on-scroll stagger-${(i % 4) + 1} gallery-item`}
              style={{ aspectRatio: '1/1', borderRight: '1px solid #1C1C1C', borderBottom: '1px solid #1C1C1C' }}
            >
              <AppImage
                src={img?.src}
                alt={img?.alt}
                fill
                className="object-cover"
              />
              <div className="overlay" suppressHydrationWarning />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
